const escapeCharacter = (match) => {
  switch (match) {
    case '&': return '&amp;';
    case '<': return '&lt;';
    case '>': return '&gt;';
    case '"': return '&quot;';
    case '\'': return '&#039;';
    case '`': return '&#096;';
    default: return match;
  }
};

export function html(html: string): string {
  if (typeof html !== 'string') {
    return '';
  }

  return html.replace(/[&<>"'`]/g, escapeCharacter);
}
